export const getFilteredQueryParams = (filters) =>
    Object.entries(filters).reduce((acc, [key, value]) => {
        if (value) {
            acc[key] = value;
        }

        return acc;
    }, {});
